module.exports = __webpack_public_path__ + "img/11_noff_open_L2.e734ee36.svg";